import styled from 'styled-components';

const ShowDepartmentsDiv = styled.div`
  background: #FFFFFF
  display: flex;
  align-items: center;
  padding-left: 10px;
  height: 40px;
  position: absolute;
  width: 100%;
  overflow: hidden;
  ${({ showDepartments }) => (showDepartments ? 'transition: max-height 0.1s linear' : '')};
  max-height: ${({ showDepartments }) => (showDepartments ? '100%' : '0')};
`;

export default ShowDepartmentsDiv;
